export var getDefaultStyle = function (visible) { return ({
    display: visible ? 'flex' : 'none',
}); };
